// extracted by mini-css-extract-plugin
export default {"bankImage":"bankImage_bankImage__0GO7P"};